module.exports = __webpack_public_path__ + "static/media/american-flag.099cc06d.png";